// extracted by mini-css-extract-plugin
module.exports = {"button":"ChatContact_button___EE23","description":"ChatContact_description__1IVLp","moreOptions":"ChatContact_moreOptions__HkkdI"};